import i18next from "i18next";
import { CopyrightText, Separator } from "./style";

const FooterBottomComponent = () => {
  const { t } = i18next;

  return (
    <>
      <Separator />
      <CopyrightText>{t("copyright")}</CopyrightText>
    </>
  );
};

export default FooterBottomComponent;
